// export const getUserLocation = async () => {
//   if (navigator.geolocation) {
//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;

//         try {
//           const response = await fetch(
//             `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`,
//           );

//           const data = await response.json();
//           console.log('getUserLocation', data);
//           return data;
//         } catch (err) {
//           console.log(`Error fetching user's location:`, err.message);
//         }
//       },
//       (err) => console.log(`Error fetching user's location:`, err.message),
//       { timeout: 10000 }, // Timeout after 10 seconds
//     );
//   } else {
//     console.log(
//       `Error fetching user's location:`,
//       'Geolocation is not supported by this browser.',
//     );
//   }
// };

// export const getUserLocation = async () => {
//   return new Promise((resolve, reject) => {
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         async (position) => {
//           const { latitude, longitude } = position.coords;

//           try {
//             const response = await fetch(
//               `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&addressdetails=1`
//             );

//             if (!response.ok) {
//               throw new Error('Failed to fetch location data');
//             }

//             const data = await response.json();
//             console.log('getUserLocation', data);
//             resolve(data);
//           } catch (err) {
//             console.error('Error fetching location data:', err.message);
//             reject(err);
//           }
//         },
//         (err) => {
//           console.error('Error retrieving geolocation:', err.message);
//           reject(err);
//         },
//         { timeout: 10000 }
//       );
//     } else {
//       const errorMsg = 'Geolocation is not supported by this browser.';
//       console.error(errorMsg);
//       reject(new Error(errorMsg));
//     }
//   });
// };

// export const fetchUserLocation = async () => {
//   try {
//     const res = await fetch('https://ipapi.co/json/');
//     const data = await res.json();
//     return data;
//   } catch (error) {
//     console.log(`Error fetching user's location:`, error);
//   }
// };

export const fetchUserLocation = async () => {
  try {
    const res = await fetch('https://ipapi.co/json/');
    const data = await res.json();
    return data;
  } catch (error) {
    console.error(`Error fetching user's location:`, error);
  }
};

export const recordImpression = async (payload) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/analytics/public-page/impression`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error recording impression:', error);
  }
};

export const recordDonationClick = async (payload) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/analytics/public-page/donation-click`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error recording donation click:', error);
  }
};

export const recordShareClick = async (payload) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/analytics/public-page/share-click`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error recording share click:', error);
  }
};

export const recordView = async (payload) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/analytics/public-page/view`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error recording view:', error);
  }
};

export const fetchSiteMapPublicProfileCommunities = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/public-profile-communities`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error fetching sitemap public profile communities:', error);
    return [];
  }
};

export const fetchSiteMapPublicProfileUsers = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/public-profile-users`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error fetching sitemap public profile users:', error);
    return [];
  }
};

export const countSiteMapPublicPosts = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/public-posts/count`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    console.log('countSiteMapPublicPosts', data);
    return data;
  } catch (error) {
    console.log('Error fetching sitemap public posts:', error);
    return 0;
  }
};

export const fetchSiteMapPublicPosts = async (offset, limit) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/public-posts/?offset=${offset}&limit=${limit}`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error fetching sitemap public posts:', error);
    return [];
  }
};

export const countSiteMapNonProfits = async () => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/nonprofits/count`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error fetching sitemap nonprofits count:', error);
    return 0;
  }
};

export const fetchSiteMapNonProfits = async (start, end) => {
  try {
    const res = await fetch(
      `${process.env.NEXT_PUBLIC_API_HOST}/v1/public/sitemap/nonprofits/?start=${start}&end=${end}`,
      { cache: 'no-store' },
    );

    const { data } = await res.json();
    return data;
  } catch (error) {
    console.log('Error fetching sitemap nonprofits', error);
    return [];
  }
};
